export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/08ee3b32e72dd5b2b700754671ea2016.svg";